import React from 'react';
import { Helmet } from 'react-helmet-async';
import SocialFacebookIcon from '@moda/icons/social-facebook-16';
import { logger } from '../../lib/logger';
import { CONFIG } from '../../config';
import { ShareLink } from './ShareLink';

const shareOnFacebook = () => {
  if (!window.FB) {
    logger.warn('FB_SHARE', "Facebook SDK hasn't loaded.");
  }

  const url = location.origin + location.pathname + '?utm_source=facebook&utm_medium=share';
  window.FB?.ui({ method: 'share', href: url });
};

const FacebookSDKScript: React.FC = () => {
  return (
    <Helmet>
      <script type="text/javascript">
        {`window.fbAsyncInit = function() {
            FB.init({ appId : ${CONFIG.FACEBOOK_APP_ID}, xfbml : true, status: true, version: 'v5.0' });
          };`}
      </script>
      <script
        id="facebook-jssdk"
        type="text/javascript"
        async
        src="https://connect.facebook.net/en_US/sdk.js"
      />
    </Helmet>
  );
};

export const FacebookShareLink: React.FC = () => {
  // TODO: MOJO:
  // * modernize this facebook tool, bring in NPM package possibly
  // * extract config info for environment
  return (
    <ShareLink
      aria-label="Share with Facebook"
      handleClick={() => shareOnFacebook()}
      data-testid="facebook-share-link"
    >
      <FacebookSDKScript />
      <SocialFacebookIcon />
    </ShareLink>
  );
};
